import { Component } from '@angular/core';
import {AddToSavedCartComponent} from "@spartacus/cart/saved-cart/components";
import {Cart} from "@spartacus/cart/base/root";
import {take} from "rxjs/operators";

@Component({
  selector: 'cx-add-to-saved-cart',
  templateUrl: './gonvarri-add-to-saved-cart.component.html',
  styleUrl: './gonvarri-add-to-saved-cart.component.scss',
  standalone: false,
})
export class GonvarriAddToSavedCartComponent extends AddToSavedCartComponent {

  override saveCart(cart: Cart): void {
    if (this.loggedIn) {
      this.openDialog(cart);
    } else {
      this.routingService.go({ cxRoute: 'login' });
    }
  }

  override openDialog(cart: Cart) {
    const dialog = this.launchDialogService.openDialog(
      "GONVARRI_SAVED_CART",
      this.element,
      this.vcr,
      { cart, layoutOption: 'save' }
    );

    if (dialog) {
      this.subscription.add(dialog.pipe(take(1)).subscribe());
    }
  }

}
